import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useRef, useState } from 'react';
import { Button, useToast, useTheme, Panel } from '@vertesia/ui/core';
import { useUserSession } from '@vertesia/ui/session';
import { MonacoEditor } from '@vertesia/ui/widgets';
import { useUITranslation } from '../../../i18n/index.js';
export function TableLayoutEditor({ objectType, onLayoutUpdate, readonly = false }) {
    const toast = useToast();
    const { theme } = useTheme();
    const { t } = useUITranslation();
    const [isUpdating, setUpdating] = useState(false);
    const { store } = useUserSession();
    const editorRef = useRef(undefined);
    const value = useMemo(() => {
        return stringifyTableLayout(objectType.table_layout);
    }, [objectType.table_layout]);
    const validationError = (title, message) => {
        toast({
            status: 'error',
            title: title,
            description: message,
            duration: 5000
        });
    };
    const onSave = () => {
        if (!editorRef.current) {
            return;
        }
        const value = editorRef.current.getValue();
        let table_layout;
        if (!value) {
            table_layout = null;
        }
        else {
            try {
                table_layout = JSON.parse(value);
            }
            catch (err) {
                return validationError('Invalid JSON', err.message);
            }
        }
        if (!Array.isArray(table_layout)) {
            return validationError('Invalid JSON', 'The table layout must be an array');
        }
        if (table_layout.some((col) => !col || !col.name || !col.field)) {
            return validationError('Invalid JSON', 'A table layout entry must contain the following properties:] {field, name, converter?}');
        }
        setUpdating(true);
        store.types.update(objectType.id, {
            table_layout
        }).then((response) => {
            toast({
                status: 'success',
                title: t('store.tableLayoutUpdated'),
                description: t('store.tableLayoutUpdatedDesc'),
                duration: 2000
            });
            onLayoutUpdate(response.table_layout);
        }).catch((err) => {
            toast({
                status: 'error',
                title: t('store.failedToUpdateTableLayout'),
                description: err.message,
                duration: 5000
            });
        }).finally(() => {
            setUpdating(false);
        });
    };
    return (_jsx(Panel, { title: "Table Layout Editor", className: "bg-background! h-full", action: !readonly ? _jsx(Button, { isLoading: isUpdating, variant: "outline", size: "sm", onClick: onSave, children: t('store.saveChanges') }) : undefined, children: _jsx("div", { className: "h-full", children: _jsx(MonacoEditor, { value: value, language: "json", editorRef: editorRef, theme: theme === 'dark' ? 'vs-dark' : 'vs', options: { readOnly: readonly } }) }) }));
}
export function stringifyTableLayout(obj) {
    if (!obj) {
        return '[\n\n]';
    }
    return JSON.stringify(obj, null, 2);
}
//# sourceMappingURL=TableLayoutEditor.js.map